import { reactive } from 'vue'

interface Grid {
  grid: number[][]
  rows: number
  columns: number
}

export function useGrid(): any {
  const grid = reactive({
    grid: [],
    rows: 0,
    columns: 0
  }) as Grid

  const createGrid = (rows: number, columns: number) => {
    grid.rows = rows
    grid.columns = columns

    grid.grid = new Array(rows)
    for (let r = 0; r < rows; r++) {
      const a = (grid.grid[r] = new Array(columns))
      for (let c = 0; c < columns; c++) a[c] = 0
    }
  }

  const validateGridRectangle = (row: number, column: number, height: number, width: number) => {
    for (let j = 0; j < height; j++) {
      for (let k = 0; k < width; k++) {
        const r = grid.grid[row + j]
        if (!r) return false
        if (r[column + k] === undefined) return false
        // if (r[column + k] > 0) return false
      }
    }
    return true
  };

  const placeGridRectangle = (row: number, column: number, height: number, width: number, id: number) => {
    for (let j = 0; j < height; j++) {
      for (let k = 0; k < width; k++) {
        grid.grid[row + j][column + k] = id
      }
    }
  };

  const addToGrid = (row: number, column: number, height: number, width: number, id: number, force = false, startRow = -1) => {
    let match = false

    if (force) {
      match = validateGridRectangle(row, column, height, width)
      if (match) {
        placeGridRectangle(row, column, height, width, id)
        return { row: row, column: column, height: height, width: width }
      }
    } else {
      for (let rowc = startRow; rowc <= grid.rows && !match; rowc++) {
        for (let columnc = 0; columnc < grid.columns && !match; columnc++) {
          match = validateGridRectangle(rowc, columnc, height, width)
          if (match) {
            placeGridRectangle(rowc, columnc, height, width, id)
            return { row: rowc, column: columnc, height: height, width: width }
          }
        }
      }
    }

    return {}
  }

  const printGrid = () => {
    for (const row of [...Array(grid.rows).keys()]) {
      let r = ""
      for (const column of [...Array(grid.columns).keys()]) {
        r += grid.grid[row][column] + ' '
      }
      console.log(row, r)
    }
  }

  return { grid, createGrid, addToGrid, printGrid };
}
